// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3CEEl","header":"Messages_header__9U1z-"};